import { Injectable } from '@angular/core';

export interface LabInfo {
  labHost: string;
  ipAddress: string | null;
  instanceId: string | null;
  instanceName: string | null;
  cloudServiceType: string | null;
}

@Injectable({ providedIn: 'root' })
export class RecorderSessionService {
  sessionId: string | null = null;
  vncUrl: string | null = null;
  websiteUrl = '';
  selectedLab: LabInfo | null = null;
  isRecording = false;
}
